import React, { useState, useEffect } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { translate } from '../../../utils/language';

const DeviceModelBars = ({ dateRange }) => {
  const [topDevices, setTopDevices] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const getDatas = async () => {
    const response = await CreateAction({
      method: 'post',
      data: { dateRange },
      path: `/report/deviceModel`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;

    if (response?.result?.resultData?.firebaseService === 'NEED_PERMISSION') {
      setErrorMessage('NEED_PERMISSION');
      return;
    }
    if (!response?.result?.resultData?.rows) return setErrorMessage('NO_DATA')

    setErrorMessage('');
    const data = response?.result?.resultData.rows || {};
    const sortedData = Object.entries(data)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 5);

    setTopDevices(sortedData);
  };

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) getDatas();
  }, [dateRange]);

  const maxCount = topDevices.length > 0 ? topDevices[0][1] : 0;

  return (
    <div>
      <div
        style={{
          fontSize: '17px',
          color: '#494949',
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingTop: '20px',
          paddingBottom: '20px',
          borderBottom: '1px solid #E5E7EB',
        }}
      >
        Cihaz Modeli Verisi
      </div>
      {errorMessage ? (
        <div className="p-2">
          <div className="text-red-500 text-center py-4">
            {translate(errorMessage)}
          </div>
        </div>
      ) : (
        <div>
          {topDevices.length > 0 &&
            topDevices.map(([device, count], index) => {
              const barWidth = maxCount > 0 ? (count / maxCount) * 60 : 0;
              const isLast = index === topDevices.length - 1;
              return (
                <div
                  key={index}
                  style={{
                    marginLeft: '15px',
                    marginRight: '15px',
                    paddingTop: '15px',
                    paddingBottom: '15px',
                    borderBottom: isLast ? 'none' : '1px solid #E5E7EB',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ fontWeight: 500, color: '#808080', fontSize: '13px' }}>{device}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div
                      style={{
                        height: '9px',
                        backgroundColor: '#7059EF',
                        width: `${barWidth}%`,
                        borderRadius: '10px',
                      }}
                    ></div>
                    <div style={{ fontWeight: 500, color: '#7059EF', fontSize: '13px' }}>{count}</div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default DeviceModelBars;
